export default __webpack_public_path__ + "static/brzytwa-mac-e5c2faa5aef589407a82cd2f6df369e1.png";